<template>
  <span>
    <v-row class="canvas__wrapper">
      <canvas id="the-canvas"></canvas>
    </v-row>
    <v-container id="printedContainer" class="header__container my-2 px-0">
      <v-row no-gutters>
        <v-col cols="2">
          <img width="125" :src="require('@/assets/logo_txtwhite_bggreen.jpg')" />
        </v-col>
        <v-col cols="8">
          <v-row justify="center" class="header-title pt-2">{{$i18n.t('dialog.print.printCbreHeader')}}</v-row>
          <v-row justify="center" class="header-scale">{{$i18n.t('dialog.print.scale', {scale: Math.round(scale/100)*100})}}</v-row>
        </v-col>
        <v-spacer />
      </v-row>
    </v-container>
  </span>
</template>
<script>
export default {
  props: {
    scale: {
      type: [Number, String],
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.canvas__wrapper {
  position: absolute;
  left: 200vw;
  top: 500vh;
}
.header__container {
  width: 100%;
  position: absolute;
  top: 100vh;
  left: 100vw;
  .header-title {
    font-size: 37px;
    font-weight: 600;
  }
  .header-scale {
    font-size: 25px;
  }
}
</style>